import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "device-tablet-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11 18.7531C10.9983 18.3395 11.3319 18.0026 11.7455 18.0001C12.1604 18.0001 12.4975 18.3352 12.5 18.7501C12.5 19.1638 12.1651 19.4993 11.7515 19.5001C11.3379 19.5009 11.0016 19.1667 11 18.7531Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 2.2464C5.48122 2.2464 4.25 3.47761 4.25 4.9964V19.0039C4.25 20.5227 5.48122 21.7539 7 21.7539H17.0058C18.5246 21.7539 19.7558 20.5227 19.7558 19.0039V4.9964C19.7558 3.47762 18.5246 2.2464 17.0058 2.2464H7ZM5.75 4.9964C5.75 4.30604 6.30964 3.7464 7 3.7464H17.0058C17.6962 3.7464 18.2558 4.30604 18.2558 4.9964V19.0039C18.2558 19.6943 17.6962 20.2539 17.0058 20.2539H7C6.30964 20.2539 5.75 19.6943 5.75 19.0039V4.9964Z"
    }, null, -1)
  ])))
}
export default { render: render }